import {Endpoints} from '../../globals/api/endpoints';

export class CategoryEndpoints extends Endpoints {

  public static readonly CATEGORIES = CategoryEndpoints.VIEWER + '/category';
  public static readonly CATEGORY = CategoryEndpoints.CATEGORIES + '/' + CategoryEndpoints.CATEGORY_ID;
  public static readonly CATEGORY_PATH = CategoryEndpoints.CATEGORY + '/path';
}
